import React from 'react';
import { Card, CardContent, Stack, Typography } from 'components/base';
import { HowToRegOutlinedIcon } from 'assets/icons';
import { Button } from 'components/atoms';
import { useAppNavigation } from 'hooks/useAppNavigation';
import { iconDiv } from '../../styles';
import { useQRStore } from '../../store/useQRStore';

export const VariconUserDetail: React.FC = () => {
  const { dataFromURL, userDetail, mobileNumber } = useQRStore();
  const { navigateTo } = useAppNavigation();

  const handleContinueToForm = () => {
    navigateTo(
      `/forms/form-results/add-response/${dataFromURL?.formID}?from_QR=${dataFromURL?.fromQR}?link_id=${dataFromURL?.linkID}?has_prefill=${dataFromURL?.hasPrefill}`,
    );
  };
  return (
    <Card raised sx={{ maxWidth: '80%' }}>
      <CardContent>
        <Stack p={2} spacing={2}>
          <Stack sx={iconDiv} bgcolor="success.background">
            <HowToRegOutlinedIcon fontSize="large" color="success" />
          </Stack>
          <Typography variant="h5" color="text.primary" alignSelf="center">
            Welcome Back, {userDetail?.first_name} {userDetail?.last_name} !
          </Typography>
          <Typography variant="body2" color="text.secondary" alignSelf="center">
            We recognize your Varicon account. Your submission wil be recorded
            under your profile
          </Typography>
          <Stack
            p={2}
            spacing={1}
            bgcolor="primary.background"
            borderRadius={2}
          >
            <Typography variant="subtitle2" color="normalText.light">
              Mobile: {mobileNumber}
            </Typography>
            <Typography variant="subtitle2" color="normalText.light">
              Email: {userDetail?.email}
            </Typography>
          </Stack>

          <Button onClick={handleContinueToForm}>Continue to Form</Button>
        </Stack>
      </CardContent>
    </Card>
  );
};
